export const transitionCubic1 =
  "transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);";
